import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/otec/pic1_01.png'
import _imports_1 from '../../assets/otec/pic2_01.png'
import _imports_2 from '../../assets/otec/pic3_01.png'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"kv\"><div class=\"caption\"><h1>海洋溫差發電</h1></div></div><section class=\"sect1\"><div class=\"ctx\"><div class=\"sectTit\">全球首座MW 級海洋溫差發電基地在和平</div><br><div class=\"left\"><div>台灣是面積不大的海島國家，受限於自然資源及土地面積在發展再生能源方面有著不小的先天劣勢，目前國內再生能源以太陽光電和風力為主，但這兩者皆是「看天吃飯」的發電模式，太陽光電僅能白天發電且每逢雨天就無法發電，而適合風力發電的風況則多出現在冬季，對於缺電最嚴重的夏季幫助有限，綠電的來源需要多元、穩定、分散才是台灣發展綠能的長期解方。</div><p>台泥企業團是目前國內投入再生能源項目最廣的企業，旗下台泥綠能擁有光電、陸域風機、漁電共生、地熱發電等案場，目前正攜手和平電力規劃在電廠所在的區域展開全球第一個 MW 級的海洋溫差發電基地，希望為四面環海的台灣找到 24 小時綠色基載電力的新機會。</p></div><div class=\"right\"><img src=\"" + _imports_0 + "\"></div><div class=\"clear\"></div><div class=\"gallery\"><div class=\"left\"><div class=\"imgContainer1-1\"></div><div class=\"imgContainer1-2\"></div></div><div class=\"right\"><div class=\"imgContainer1-3\"></div></div></div></div></section><section class=\"sect2\"><div class=\"ctx\"><div class=\"sectTit\">何謂海洋溫差發電?</div><p>地球面積 70% 為海洋所覆蓋，「海洋能」是目前備受關注的再生能源之一，海洋能源有洋流發電、潮汐發電、波浪發電及溫差發電，其中溫差發電適合於中、低緯度溫暖的表層海水帶。</p><p>地球上最大的能量來源為太陽的輻射，而吸收太陽輻射最大的載體就是大海，表層海水經過太陽日照而升溫，而深層海水因陽光無法透入而維持穩定的冰冷低溫。</p><div class=\"contOver\"><img src=\"" + _imports_1 + "\"></div><p>海洋溫差發電（英語：Ocean Thermal Energy Conversion, OTEC）主要是透過海洋表層的「溫」海水與海洋深層的「冷」海水進行「熱交換」，達到「熱能」轉換成「電能」的效果。</p><p>相較於太陽能與風電等其他綠色能源有間歇性的情況，海洋溫差發電可 24 小時運用，被視為可靠的基載電力來源。</p></div></section>", 3)
const _hoisted_4 = { class: "sect3" }
const _hoisted_5 = { class: "ctx" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "和平電力發展海洋溫差發電優勢", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "海洋溫差發電的關鍵是如何能容易取得深層的海水，台灣東部海域擁有獨特且特殊的海溝地形，和平電廠位於花蓮，向外海 1.6 公里處就可達到水深 600 公尺的深度，對於深層海水取水有相當大的優勢，偵測水溫約 7℃。", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "表層海水水溫依照季節大約 25-29℃，目前溫差發電機組的設計是與和平電廠結合在一起，這也是一項優勢，因為平時電廠運作就會需要取用海水做為蒸汽餘熱降溫的未接觸冷卻用水來使用，這些水使用過後，溫度又會比表層海水溫度高 5-6 度，如此一來利用溫差能發電的效率就更加提高。", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("p", null, "若建設完成後將會是台灣首座大型海洋溫差發電系統也是世界第一座 MW 級商業運轉的海洋溫差發電廠，預估每部機組每天可穩定發電 2.4 萬度，約可供給超過 2,000 個小家庭的用電量。"),
  /*#__PURE__*/_createElementVNode("p", null, "目前水下文化資產已經完成調查，環境影響評估 (EIA) 作業進行中，預計第一階段設計裝置容量 1-2 MW，目標 2028 年完成併網。")
], -1)
const _hoisted_10 = { class: "right" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "txt" }, [
  /*#__PURE__*/_createTextVNode("世界第一座商業運轉 MW 級"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("海洋溫差發電系統")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "day" }, "穩定發電 / 日", -1)
const _hoisted_15 = { ref: "runData" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "num1" }, "24000", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stick" }, "供給"),
  /*#__PURE__*/_createElementVNode("div", { class: "tri" })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "num2" }, "2000", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = { class: "sect4" }
const _hoisted_21 = { class: "ctx" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "和平電力團隊訪察久米島 OTEC 示範電廠", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("section", { class: "sect5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ctx" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "國際海洋溫差發電技術發展"),
    /*#__PURE__*/_createElementVNode("p", null, "1973 年世界第一次能源危機發生掀起大規模研究海洋溫差發電熱潮，但隨著能源危機的解除而中斷，後來美、日兩國 2007 年開始重新啟動 OTEC 技術研發並以商業運轉模組為開發目標，其中美國 Lockheed Martin 公司結合 Makai 工程公司，於 2008 年在夏威夷規劃 100MW 商業型電廠建置計畫，2009 年更獲得美國海軍資助進行 OTEC 可行性計畫，評估於夏威夷、關島、波多黎各、琉球、Diego Carcia 等建廠研究，推動至今 Makai 公司已於 2015 年在夏威夷 NELHA 園區完成可供應 105kW 的 OTEC 電廠建置（深層海水日取水量 16 萬噸），現今更銜接當地電網，供應約 200 戶家庭使用。"),
    /*#__PURE__*/_createElementVNode("p", null, "另外，日本以佐賀大學為主的研發團隊則在 1980 年代開始投入 OTEC 相關技術研發，對於熱交換器及新型發電系統著墨最多引領相關技術推動，2013 年佐賀大學結合 Xenesys 公司、IHI 工程建設公司及河電機公司於久米島完成建置 2 座 50kW 之 OTEC 示範電廠並實施連續運轉試驗至今，和平電力公司團隊在 2022 年時也到了日本久米島進行訪察，思考的是怎麼把這些經驗帶回台灣、如何讓發電規模更大更穩定。"),
    /*#__PURE__*/_createElementVNode("p", null, "目前日本與美國的兩個電廠都已具有商業化規模與超過 10 年長期運轉的實績，只是都還是 kW 級的海洋溫差電廠，而和平電力是預計投入 MW 級的海洋溫差能的開發。")
  ])
], -1)
const _hoisted_24 = { class: "sect6" }
const _hoisted_25 = { class: "ctx" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "國際海洋溫差發電歷程", -1)
const _hoisted_27 = { class: "history" }
const _hoisted_28 = { class: "year" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "dash" }, null, -1)
const _hoisted_30 = { class: "desp" }
const _hoisted_31 = { class: "sect7" }
const _hoisted_32 = { class: "ctx" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "未來和平電廠海洋深層水 關聯產業", -1)
const _hoisted_34 = { class: "industry" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "tit" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<section class=\"sect8\"><br><div class=\"ctx\"><div class=\"sectTit\">海洋溫差發電的附加價值</div><p>海洋溫差發電後的深層水依然擁有其高營養鹽、乾淨的特點，以日本久米島海洋溫差發電設施來看，當中深層海水日取水量 1.3 萬噸，深層海水可應用於龍膽石斑魚等高經濟水產養殖、SPA 水療觀光、富含礦物質的海洋深層飲用水等延伸產業。</p><p>另台灣東海岸深層海水的溶解鹽類大約是表層的 15 倍以上，此種高濃度的營養鹽類有助於海水養殖、製藥或生物科技的發展，冷海水的冷度可用於空調、冷藏或農業生產等區域供冷等需求。</p><p>以國外經驗來看，產業應用層面相當廣泛，待運行成效穩定後，這些都可作為未來在地深層水發展潛力的參考。</p><div class=\"gallery\"><div class=\"left\"><div class=\"imgContainer8-1\"><div class=\"imgTit\">海洋深層水蔬菜種植</div></div></div><div class=\"right\"><div class=\"imgContainer8-2\"><div class=\"imgTit\">海洋深層水養殖</div></div></div></div></div><br></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(" 度 "),
              _hoisted_17,
              _hoisted_18,
              _createTextVNode(" 戶 ")
            ], 512)
          ]),
          _hoisted_19
        ])
      ]),
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_swiper, {
            modules: _ctx.modules,
            "slides-per-view": 1,
            "space-between": 1,
            autoplay: {delay:3000, disableOnInteraction:false},
            speed: 1000,
            loop: true,
            pagination: {clickable:true},
            onSwiper: _ctx.onSwiper,
            onSlideChange: _ctx.onSlideChange,
            class: "swiper"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, { class: "cover cover1" }),
              _createVNode(_component_swiper_slide, { class: "cover cover2" }),
              _createVNode(_component_swiper_slide, { class: "cover cover3" }),
              _createVNode(_component_swiper_slide, { class: "cover cover4" }),
              _createVNode(_component_swiper_slide, { class: "cover cover5" })
            ]),
            _: 1
          }, 8, ["modules", "onSwiper", "onSlideChange"])
        ])
      ]),
      _hoisted_23,
      _createElementVNode("section", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otecHistory, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(row.year) + " 年", 1),
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, _toDisplayString(row.desp), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industry, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("img", {
                  class: "icon",
                  src: _ctx.setIndustryIcon(row.icon)
                }, null, 8, _hoisted_35),
                _createElementVNode("div", _hoisted_36, _toDisplayString(row.tit), 1),
                _createElementVNode("div", {
                  class: "desp",
                  innerHTML: row.desp
                }, null, 8, _hoisted_37)
              ]))
            }), 128))
          ])
        ])
      ]),
      _hoisted_38
    ]),
    _createVNode(_component_Footer)
  ], 64))
}